import { useEffect, useRef } from "react";
import { Icon } from "../components/Icon";
import { t } from "../i18n";

/**
 * Фото на весь экран. Закрывается крестиком, Esc и нажатием мимо картинки; фокус — на
 * крестик, после закрытия — обратно на превью, с которого открыли (иначе с клавиатуры и
 * в VoiceOver теряешь место в переписке).
 */
export function Lightbox({ url, label, onClose, returnFocus }: { url: string; label: string; onClose: () => void; returnFocus: HTMLElement | null }) {
  const closeButton = useRef<HTMLButtonElement>(null);
  const close = useRef(onClose);
  close.current = onClose;

  useEffect(() => {
    closeButton.current?.focus();
    const onKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") close.current();
      // Внутри одна кнопка — Tab не должен уводить фокус под затемнение
      if (event.key === "Tab") {
        event.preventDefault();
        closeButton.current?.focus();
      }
    };
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("keydown", onKey);
      returnFocus?.focus();
    };
  }, [returnFocus]);

  return (
    <div className="lightbox" role="dialog" aria-modal="true" aria-label={label} onClick={onClose}>
      <img className="lightbox__img" src={url} alt={label} onClick={(event) => event.stopPropagation()} />
      <button type="button" ref={closeButton} className="icon-btn lightbox__close" onClick={onClose} aria-label={t("app.close")}>
        <Icon name="close" />
      </button>
    </div>
  );
}
